/* Pop-up ZZCLUB (sections/newsletter-popup.liquid).
   Aparece 12 segundos después de abrir la tienda, con entrada suave (CSS en la sección).
   Se muestra como máximo una vez cada data-expiry días (1 = una vez por día):
   queda marcado apenas se abre, con cookie y localStorage, así no vuelve a
   aparecer en cada página aunque no lo cierren con la X.
   Las imágenes se cargan antes de abrir, así la tarjeta entra completa de una sola vez. */
class SubscriptionPopup extends HTMLElement {
  constructor() {
    super();
    if (window.location.pathname === '/challenge') return;
    this.cookieName = 'fusion:subscription-popup';
    this.storageKey = 'ez:zzclub-popup';
    this.delay = 12000;
    this.popup = this;
    this.opening = false;
    this.classes = {
      bodyClass: 'subscription-modal-open',
      overlayCLass: 'overflow-hidden',
      activeClass: 'is-visible',
      closingClass: 'closing'
    };
    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    if (!this.seenRecently()) {
      /* Precargar imagen y logo del pop-up para que no aparezcan después de la tarjeta */
      this.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      this.init();
    }
  }
  days() {
    var d = parseInt(this.dataset.expiry, 10);
    return d > 0 ? d : 1;
  }
  seenRecently() {
    if (this.getCookie(this.cookieName)) return true;
    try {
      var t = parseInt(localStorage.getItem(this.storageKey), 10);
      if (t && Date.now() - t < this.days() * 86400000) return true;
    } catch (e) {}
    return false;
  }
  markSeen() {
    document.cookie = this.cookieName + '=true; max-age=' + this.days() * 86400 + '; path=/; SameSite=Lax';
    try { localStorage.setItem(this.storageKey, String(Date.now())); } catch (e) {}
  }
  init() {
    /* El tiempo cuenta desde que se abrió la tienda en esta pestaña, aunque la clienta cambie de página. */
    var start = Date.now();
    try {
      var saved = parseInt(sessionStorage.getItem('ez:zzclub-start'), 10);
      if (saved) start = saved; else sessionStorage.setItem('ez:zzclub-start', String(start));
    } catch (e) {}
    var wait = Math.max(1500, this.delay - (Date.now() - start));
    this.timer = setTimeout(() => this.tryOpen(), wait);
  }
  tryOpen() {
    /* No encimar el pop-up si hay otro panel abierto (carrito, menú, etc.): reintenta en unos segundos. */
    if (document.body.classList.contains(this.classes.overlayCLass)) {
      this.timer = setTimeout(() => this.tryOpen(), 5000);
      return;
    }
    this.open();
  }
  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }
  open() {
    if (this.dataset.subscriptionpopup != 'true') return;
    if (this.opening || this.classList.contains(this.classes.activeClass)) return;
    this.opening = true;
    var imgs = Array.prototype.slice.call(this.querySelectorAll('img'));
    var ready = Promise.all(imgs.map(function (img) {
      return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    }));
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 1500); });
    Promise.race([ready, timeout]).then(() => {
      this.opening = false;
      this.show();
    });
  }
  show() {
    this.markSeen();
    document.body.classList.add(this.classes.bodyClass);
    document.body.classList.add(this.classes.overlayCLass);
    this.popup.classList.add(this.classes.activeClass);
  }
  close() {
    this.popup.classList.add(this.classes.closingClass);
    document.body.classList.remove(this.classes.overlayCLass);
    document.body.classList.remove(this.classes.bodyClass);
    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
    }, 450);
    this.markSeen();
  }
  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }
}
if (!customElements.get('subscription-popup')) customElements.define('subscription-popup', SubscriptionPopup);
